// Window events that change what's waiting in Review. The nav badge
// (useReviewSummary) re-reads its counts on each; the Waiting list re-reads
// the source that changed.

/** Dispatched after any Add or Dismiss made on the Review page (or the moved Ideas, Transcripts and Images bodies). */
export const REVIEW_CHANGED_EVENT = 'cadence:review-changed';
/** An agent sent something to Review, or a proposal was decided elsewhere (SignalR AgentProposalsChanged, re-broadcast by the shell). */
export const AGENT_PROPOSALS_CHANGED_EVENT = 'cadence:agent-proposals-changed';
/** A transcript's background analysis finished (SignalR TranscriptAnalysed, re-broadcast by AppLayout). */
export const TRANSCRIPT_ANALYSED_EVENT = 'cadence:transcript-analysed';
/** A work item changed (SignalR WorkItem*, re-broadcast by AppLayout). */
export const WORKITEM_CHANGED_EVENT = 'cadence:workitem-changed';

/** Every event that can change the badge's counts. */
export const REVIEW_SUMMARY_REFRESH_EVENTS = [
  WORKITEM_CHANGED_EVENT,
  TRANSCRIPT_ANALYSED_EVENT,
  AGENT_PROPOSALS_CHANGED_EVENT,
  REVIEW_CHANGED_EVENT,
] as const;

/** Tell the badge (and anything else listening) that something in Review was just decided. */
export function notifyReviewChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(REVIEW_CHANGED_EVENT));
}
